import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import AddSrc from 'assets/images/icons/DesignSysten2.0/symbols_warning_safety/Mais.svg';
import WarningSrc from 'assets/images/icons/DesignSysten2.0/symbols_warning_safety/Exclamação Triangulo.svg';
import CloseSrc from 'assets/images/icons/DesignSysten2.0/symbols_warning_safety/X.svg';
import StampSrc from 'assets/images/icons/DesignSysten2.0/symbols_warning_safety/Selo.svg';
import WarningCircleSrc from 'assets/images/icons/DesignSysten2.0/symbols_warning_safety/Exclamação Círculo.svg';
import InfoSrc from 'assets/images/icons/DesignSysten2.0/symbols_warning_safety/InfoTooltip.svg';
import PadlockSrc from 'assets/images/icons/DesignSysten2.0/symbols_warning_safety/Cadeado.svg';

interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const Warning: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={WarningSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Add: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={AddSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Close: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CloseSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Stamp: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => <SVG src={StampSrc} style={{ width, height }} cacheRequests />;
export const WarningCircle: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={WarningCircleSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Padlock: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={PadlockSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const Info: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={InfoSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
